import { MainComponent } from "./components";
import { TableProvider } from "./providers";

export function ListPage() {
  return (
    <TableProvider>
      <MainComponent />
    </TableProvider>
  );
}
